import { DesignationService } from './../../../_services/designation.service';
import { ToastrService } from 'ngx-toastr';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DepartmentService } from '../../../_services/department.service';
import { UnitService } from '../../../_services/unit.service';
import { GlobalService } from '../../../_services/global.service';
import { DivisionService } from '../../../_services/division.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ResponseStructure } from '@iq-central-front-end/share';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'iq-central-front-end-setting-structure',
  templateUrl: './setting-structure.component.html',
  styleUrls: ['./setting-structure.component.scss'],
})
export class SettingStructureComponent implements OnInit, OnDestroy {
  divisionCloseModal: ElementRef;
  departmentForm;
  departments: any[] = [];
  divisions: any[] = [];
  designations: any[] = [];
  units: any[] = [];
  divisionForm: FormGroup;
  designationForm;
  unitForm: FormGroup;

  sub: Subscription = new Subscription();
  profiles;
  constructor(
    private _department: DepartmentService,
    private _unit: UnitService,
    private _global: GlobalService,
    private _division: DivisionService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private _toastr: ToastrService,
    private _designation: DesignationService
  ) {}

  ngOnInit(): void {
    this.getResolvedData();
    this.initDivisionForm();
    this.initUnitForm();
  }

  getResolvedData() {
    this.sub.add(
      this.route.data.subscribe((res) => {
        this.departments = res['resolvedData'].allDepartments['responseResult'];
        console.log(this.departments.length);
        this.divisions = res['resolvedData'].allDivisions['responseResult'];
        this.designations =
          res['resolvedData'].allDesignations['responseResult'];
        this.units = res['resolvedData'].allUnits['responseResult'];
      })
    );
  }

  initDivisionForm() {
    this.divisionForm = this.fb.group({
      departmentId: ['', Validators.required],
      nameOnlyRequestDTOS: [''],
    });
  }

  initUnitForm() {
    this.unitForm = this.fb.group({
      divisionId: ['', Validators.required],
      nameOnlyRequestDTOS: [''],
    });
  }

  addDepartment() {
    this._global.showSpinner();
    var payload = [{ name: this.departmentForm }];

    this._department.createDepartment(payload).subscribe({
      next: (res: ResponseStructure) => {
        this.departmentForm = '';

        this.departments.push(res.responseResult[0]);
        this._global.successHandlerWithObject(res);
      },
    });
  }

  addDesignation() {
    this._global.showSpinner();
    var payload = [{ name: this.designationForm }];

    this._designation.createDesignation(payload).subscribe({
      next: (res: ResponseStructure) => {
        this.designationForm = '';
        this.designations.push(res.responseResult[0]);
        this._global.successHandlerWithObject(res);
      },
    });
  }
  addDivision() {
    this._global.showSpinner();
    const payload = this.divisionForm.value;
    const nameOnlyRequestDTOS = [{ name: payload.nameOnlyRequestDTOS }];
    const departmentId = payload.departmentId;
    this._division.createDivision(nameOnlyRequestDTOS, departmentId).subscribe({
      next: (res: ResponseStructure) => {
        this.divisionForm.reset();

        this.divisions.push(res.responseResult[0]);
        this._global.successHandlerWithObject(res);
      },
    });
  }

  addUnit() {
    this._global.showSpinner();
    const payload = this.unitForm.value;
    const nameOnlyRequestDTOS = [{ name: payload.nameOnlyRequestDTOS }];
    const divisionId = payload.divisionId;
    this._unit.createUnit(nameOnlyRequestDTOS, divisionId).subscribe({
      next: (res: ResponseStructure) => {
        this.unitForm.reset();

        this.units.push(res.responseResult[0]);
        this._global.successHandlerWithObject(res);
      },
    });
  }

  deleteDepartment(department) {
    this._department.deleteDepartment(department.id).subscribe({
      next: (res: ResponseStructure) => {
        this._global.globalSuccessHandler(res);
        this.departments = this.departments.filter(
          (d) => d.id !== department.id
        );
      },
    });
  }
  deleteDesignation(designation) {
    this._designation.deleteDesignation(designation.id).subscribe({
      next: (res: ResponseStructure) => {
        this._global.globalSuccessHandler(res);
        this.designations = this.designations.filter(
          (d) => d.id != designation.id
        );
      },
    });
  }

  deleteDivision(division) {
    this._division.deleteDivision(division.id).subscribe({
      next: (res: ResponseStructure) => {
        this.divisions = this.divisions.filter((d) => d.id != division.id);
        this._global.globalSuccessHandler(res);
      },
    });
  }

  deleteUnit(unit) {
    this._unit.deleteUnit(unit.id).subscribe({
      next: (res: ResponseStructure) => {
        this.units = this.units.filter((d) => d.id != unit.id);
        this._global.globalSuccessHandler(res);
      },
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
